import { configureStore } from '@reduxjs/toolkit'
import loginSlice from '../slices/login_slices'
import itemSlice from '../slices/item_slices'

export default configureStore({
    reducer: {
      login: loginSlice,
      item: itemSlice
    },
  })